import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  deleteAwardceremony,
  getAwardceremony,
} from "../../../../services/AwardceremonyService";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";

const AwardceremonyList = () => {
  const [awardceremony, setAwardceremony] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchAwardceremony();
  }, []);

  const fetchAwardceremony = async () => {
    try {
      const data = await getAwardceremony();
      setAwardceremony(data);
    } catch (error) {
      console.error("Error fetching awardceremony:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteAwardceremony(id);
      fetchAwardceremony(); // Refresh list after deletion
      console.log("Awardceremony deleted successfully");
    } catch (error) {
      console.error("Error deleting awardceremony:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "label", title: "Label" },
    { prop: "value", title: "Value" },
    { prop: "createdAt", title: "Created At" },
    { prop: "updatedAt", title: "Updated At" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={"/settings/awardceremonies/edit/" + row._id}
            variant="primary"
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = awardceremony.map((awardceremony) => ({
    label: awardceremony.label,
    value: awardceremony.value,
    createdAt: moment(awardceremony.createdAt).format("YYYY-MM-DD"),
    updatedAt: moment(awardceremony.updatedAt).format("YYYY-MM-DD"),
    _id: awardceremony._id, // Include for delete/edit actions
  }));

  // Filter the data based on the awardceremony label
  const filteredData = tableData.filter(
    (item) =>
      item.label && item.label.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Card>
      <div className="card-body">
        <Row>
          <Col xs={12}>
            <h4>Awardceremony List</h4>
            <Link
              variant="primary"
              to={"/settings/awardceremonies/add"}
              className="mb-4 d-flex justify-content-end"
            >
              <Button>Add Award Ceremony</Button>
            </Link>

            <DatatableWrapper
              body={filteredData} // Use filtered data for the table
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 5, // Set rows per page
                  options: [5, 10, 15], // Options for rows per page
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search by Awardceremony Label"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table>
                <TableHeader />
                <TableBody />
              </Table>

              <Row>
                <Col className="d-flex flex-col justify-content-start">
                  <PaginationOptions />
                </Col>
                <Col className="mt-4 d-flex  justify-content-end align-items-end">
                  <Pagination />
                </Col>
              </Row>
            </DatatableWrapper>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default AwardceremonyList;
